import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=3edf7f22&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=ts&"
export * from "./Checkout.vue?vue&type=script&lang=ts&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=3edf7f22&lang=stylus&scoped=true&"
import style1 from "./Checkout.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf7f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
